import BaseService from './BaseService'
import axios from 'axios'

export default class NewsService extends BaseService {
  static async getNews () {
    const resp = await axios.get('/api/v1/public/news')

    return this.parseResponse(resp, false)
  }

  static async getArticle (id) {
    const resp = await axios.get(`/api/v1/public/news/${id}`)

    return this.parseResponse(resp, false)
  }
}